import React from 'react';
import userRequest, {
     userApi
 } from 'common/request';
import {  Modal,Toast,Button} from 'antd-mobile';
import FileUpload   from 'component/fileUploader';
 
  
const prompt = Modal.prompt;
const alert = Modal.alert;
 
 

class FileUploader extends React.Component{
 
 
    options  (){
        const {user_id,user_name}= this.props
      
          return {
            baseUrl:window.AppConfig.mainIP + userApi.upload,
            fileFieldName(file) {
               
                return 'file';
            },
            dataType        : 'json',
            paramAddToField:{ 
                username:user_name,
                user_id,
                tenant:localStorage.getItem('tenant_code'),
                title:'添加报告',
                cate_id:'0'
            }, 
            chooseAndUpload: true,
            accept: '*',
            uploadSuccess   : (res) => {
                const {  recordAll} =this.props;
                let newReport = res;
                let  result = {}; 
                let newRecord = this.props.recordAll.toJS()
                if(newRecord.length===0){
                    result = [newReport]
                }else{
                    result = [...newRecord,newReport]
                } 
                this.props.changeRecordAll(result) 
                 
            },
            uploadError     : (err) => { 
                Toast.fail('上传失败', 2);
            }
        }
    }
    render(){
      
        return (
          <FileUpload  options={this.options()}>
            <Button inline  className="uploadBtn"  ref="chooseAndUpload">上传</Button>
          </FileUpload> 
        )           
    }
}
export default FileUploader;